import {
	TableRow,
	TableColumn,
	TableHeader,
	TableBody,
	DataTable,
} from 'react-md'
import { TableContainer } from 'ui/StyledComponents/Tables'
import type { Invoice } from '../types'
import styled from 'styled-components'
import { productHeaders } from './constants'
import { useIntl } from 'react-intl'

const StyledDataTable = styled(DataTable)`
	max-height: calc(100vh - 400px);
	td {
		white-space: nowrap;
	}
`
type Props = {
	invoice: Invoice
}

const ProductTable = ({ invoice }: Props) => {
	const intl = useIntl()
	console.log(invoice)
	const renderTableHeaders = () => {
		return (
			<TableRow>
				{productHeaders.map((header) => (
					<TableColumn key={String(header.key)}>
						<p className="text-strong text-subtle">{header.title(intl)}</p>
					</TableColumn>
				))}
			</TableRow>
		)
	}

	return (
		<TableContainer>
			<StyledDataTable plain>
				<TableHeader
					style={{
						position: 'sticky',
						top: 0,
						zIndex: 1,
					}}
				>
					{renderTableHeaders()}
				</TableHeader>

				<TableBody>
					<TableRow>
						{productHeaders.map((productHeader) => (
							<TableColumn key={String(productHeader.key)}>-</TableColumn>
						))}
					</TableRow>
				</TableBody>
			</StyledDataTable>
		</TableContainer>
	)
}

export default ProductTable
